// angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

// cc-common imports
import { Utils } from 'cc-common';

// service imports
import { ServerErrorService } from '../../../_services/shared-services/server-error.service';
import { WorkOrderService } from '../../_services/work-order.service';

// model imports
import { BaseProcessNotesResultDto } from '../../../management-common/_models/notes/base-process-notes-result-dto';
import { BaseWorkOrderParameterDto } from '../../_models/base-work-order-parameter-dto';
import { AddWorkorderNotesParamaterDto } from '../../_models/add-work-order-notes-paramater-dto';

// constant imports
import { MessageInterval } from '../../../_constants/messages-intervals';

@Component({
    selector: 'app-work-orders-notes-editor',
    templateUrl: './work-orders-notes-editor.component.html',
    styleUrls: ['./work-orders-notes-editor.component.scss']
})
export class WorkOrdersNotesEditorComponent implements OnInit {
    @ViewChild('workOrderNotesPopup', { static: false }) workOrderNotesPopup: DxPopupComponent;

    @Input() communityId: number;
    @Input() workOrderId: number;

    @Output() onClose = new EventEmitter<boolean>();

    visible = false;
    previousNotes: string;
    allowNewNotes: boolean;
    isNotesSaved = false;

    constructor(
        private readonly workOrderService: WorkOrderService,
        private readonly errorService: ServerErrorService
    ) {}

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onWorkOrderNotesPopShown(): void {
        this.workOrderNotesPopup.instance.repaint();

        this.populatePreviousNotes();
    }

    onWorkOrderNotesPopClose(): void {
        this.closeNotes();
    }

    onNotesPopClose(): void {
        this.closeNotes();
    }

    onSaveNotes(newNote: string): void {
        if (Utils.notNullOrEmpty(newNote)) {
            const baseParams: AddWorkorderNotesParamaterDto = new AddWorkorderNotesParamaterDto();
            baseParams.workOrderId = this.workOrderId;
            baseParams.communityId = this.communityId;
            baseParams.newNote = newNote;

            this.workOrderService.saveNotes(baseParams).subscribe(
                (result) => {
                    notify('Notes saved successfully.', 'Success', MessageInterval.successMsgInterval);
                    this.populatePreviousNotes();
                    this.isNotesSaved = true;
                    this.closeNotes();
                },
                (error) => {
                    this.errorService.displayError(error);
                }
            );
        }
    }

    private populatePreviousNotes(): void {
        const baseParams: BaseWorkOrderParameterDto = new BaseWorkOrderParameterDto();
        baseParams.workOrderId = this.workOrderId;
        baseParams.communityId = this.communityId;

        this.workOrderService.getWorkOrderNotes(baseParams).subscribe(
            (result: BaseProcessNotesResultDto) => {
                this.previousNotes = result.note;
                this.allowNewNotes = result.allowNewNotes;
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    private closeNotes(): void {
        this.visible = false;
        this.onClose.emit(this.isNotesSaved);
    }
}
